import { Transform, Type } from 'class-transformer';
import { BaseModel } from './baseModel';

export class WizardTask extends BaseModel {
  title: string;
  link?: string;

  // Convert backend array of params into object. Idempotente: se já chega
  // no formato de destino (object), passa direto. Isso é necessário pra que
  // `plainToClass` rode sem quebrar quando re-hidratamos o cache do
  // sessionStorage (que armazena o linkParams já transformado).
  @Transform((params: Array<{ title: string, value: string }> | { [key: string]: string }) => {
    if (params == null || !Array.isArray(params)) {
      return params;
    }
    const obj = {};
    params.forEach(param => {
      if (param.value.startsWith('EmailTrigger.')) {
        obj[param.title] = param.value.split('EmailTrigger.')[1];
      } else {
        obj[param.title] = param.value;
      }
    });

    return obj;
  })
  linkParams?: {
    [param: string]: string
  };
  checked: boolean;
}

export class WizardStep extends BaseModel {
  title: string;

  @Type(() => WizardTask)
  tasks: Array<WizardTask>;
}
